import type { Matchup } from "./bracket-types"

export const nbaMatchups: Matchup[] = [
  {
    homeTeam: {
      name: "Boston Celtics",
      shortName: "Celtics",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/bos.png",
      score: 112,
      winPercentage: 65,
      trend: "up",
      color: "#007A33",
    },
    awayTeam: {
      name: "New York Knicks",
      shortName: "Knicks",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/ny.png",
      score: 108,
      winPercentage: 35,
      trend: "down",
      color: "#006BB6",
    },
    period: "Q4",
    timeRemaining: "2:45",
    league: "NBA",
    isLive: true,
    state: "live",
    tag: "nba",
  },
  {
    homeTeam: {
      name: "Los Angeles Lakers",
      shortName: "Lakers",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/lal.png",
      score: 98,
      winPercentage: 45,
      trend: "neutral",
      color: "#552583",
    },
    awayTeam: {
      name: "Golden State Warriors",
      shortName: "Warriors",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/gs.png",
      score: 102,
      winPercentage: 55,
      trend: "up",
      color: "#1D428A",
    },
    period: "Q3",
    timeRemaining: "8:15",
    league: "NBA",
    isLive: true,
    state: "live",
    tag: "nba",
  },
  {
    homeTeam: {
      name: "Miami Heat",
      shortName: "Heat",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/mia.png",
      score: 85,
      winPercentage: 50,
      trend: "neutral",
      color: "#98002E",
    },
    awayTeam: {
      name: "Milwaukee Bucks",
      shortName: "Bucks",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/mil.png",
      score: 82,
      winPercentage: 50,
      trend: "neutral",
      color: "#00471B",
    },
    period: "Q2",
    timeRemaining: "5:30",
    league: "NBA",
    isLive: true,
    state: "live",
    tag: "nba",
  },
  {
    homeTeam: {
      name: "Denver Nuggets",
      shortName: "Nuggets",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/den.png",
      score: 115,
      winPercentage: 100,
      trend: "up",
      color: "#0E2240",
    },
    awayTeam: {
      name: "Oklahoma City Thunder",
      shortName: "Thunder",
      logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/okc.png",
      score: 110,
      winPercentage: 0,
      trend: "down",
      color: "#007AC1",
    },
    period: "Q4",
    timeRemaining: "1:15",
    league: "NBA",
    isLive: true,
    state: "live",
    tag: "nba",
  },
]
